/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { GetRecruitmentCheckLimit200, GetRecruitmentCheckLimit400, GetRecruitmentCheckLimitQueryResponse } from '../entities/GetRecruitmentCheckLimit'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { errorStructSchema } from './errorStructSchema'
import { v1CheckLimitResponseSchema } from './v1/checkLimitResponseSchema'
import { z } from 'zod'

/**
 * @description OK
 */
export const getRecruitmentCheckLimit200Schema = z.lazy(() => v1CheckLimitResponseSchema) as unknown as ToZod<GetRecruitmentCheckLimit200>

/**
 * @description Bad Request
 */
export const getRecruitmentCheckLimit400Schema = z.lazy(() => errorStructSchema) as unknown as ToZod<GetRecruitmentCheckLimit400>

export const getRecruitmentCheckLimitQueryResponseSchema = z.lazy(
  () => getRecruitmentCheckLimit200Schema,
) as unknown as ToZod<GetRecruitmentCheckLimitQueryResponse>